export function authHeader() {
  // return authorization header with jwt token
  let user = JSON.parse(localStorage.getItem("user"));

  if (user?.success.token) {
    return { Authorization: "Bearer " + user.success.token };
  } else {
    return {};
  }
}
